/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Standalone Document

1 = Change Order

3 = Selection Choice

4 = Selection

5 = Lead

6 = Purchase Order

7 = Lead Email Attachment

10 = Mail Attachment

11 = Sub Insurance Cert

12 = Sub Trade Agreement

13 = Sub File Custom Field

14 = Warranty Request

15 = Warranty File Custom Field

16 = Job Info File Custom Field

17 = Leads File Custom Field

18 = Contact File Custom Field

19 = Bid Package

20 = Bid Request

21 = Message Attachment

22 = Global Document

23 = Schedule Item

25 = Owner Invoice

26 = Lead Proposal

27 = Daily Log

28 = Estimate

29 = To-Do

30 = To Do File Custom Field

31 = Lien Waiver

32 = Signed Lien Waiver

33 = PO Payments File Custom Field

34 = Change Orders File Custom Field

35 = Proposal Cost Group

36 = Warranty Service

37 = Owner Invoices File Custom Field

38 = Cost Code Item

39 = Selection Choice Line Item

40 = Internal Users File Custom Field

41 = Daily Logs File Custom Field

42 = RFI

43 = RFI Response

44 = Bulk Export

45 = Signed Purchase Order With Payment Info

46 = Signed Purchase Order Without Payment Info

47 = Risk Insurance Binder

48 = Risk Insurance Proposal

49 = Risk Insurance Policy

50 = Risk Insurance Endorsement

51 = To-Do Checklist

52 = Selections File Custom Field

53 = Purchase Orders File Custom Field

54 = Owner Profile

55 = Credit memo

56 = Receipt

57 = Takeoff

58 = Bill

59 = Specification

60 = Deposit

61 = Electronic Consent

62 = Client Update

63 = Proof of Purchase

64 = Proposal

65 = Worksheet Agreement

66 = Proposal Agreement

67 = Task

68 = Selection Option

69 = Submittal

70 = Task File Custom Field

71 = Selection Catalog Option

72 = Sub/Vendor


 */
export type DocumentInstanceType =
  (typeof DocumentInstanceType)[keyof typeof DocumentInstanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentInstanceType = {
  StandaloneDocument: 0,
  ChangeOrder: 1,
  SelectionChoice: 3,
  Selection: 4,
  Lead: 5,
  PurchaseOrder: 6,
  LeadEmailAttachment: 7,
  MailAttachment: 10,
  SubInsuranceCert: 11,
  SubTradeAgreement: 12,
  SubsFileCustomField: 13,
  Warranty: 14,
  WarrantyFileCustomField: 15,
  JobsiteFileCustomField: 16,
  LeadsFileCustomField: 17,
  ContactFileCustomField: 18,
  BidPackage: 19,
  Bid: 20,
  MessagesEmailAttachment: 21,
  GlobalDocument: 22,
  ScheduleItems: 23,
  CustomerInvoices: 25,
  LeadProposal: 26,
  DailyLog: 27,
  Estimate: 28,
  ToDo: 29,
  ToDoFileCustomField: 30,
  LienWaiver: 31,
  SignedLienWaiver: 32,
  POPaymentsFileCustomField: 33,
  ChangeOrdersFileCustomField: 34,
  ProposalFormatItem: 35,
  WarrantyService: 36,
  OwnerPaymentsFileCustomField: 37,
  CostCodeItems: 38,
  SelectionChoiceLineItems: 39,
  LoginFileCustomField: 40,
  DailyLogsFileCustomField: 41,
  Rfi: 42,
  RfiResponse: 43,
  BulkExport: 44,
  SignedPurchaseOrderWithPayment: 45,
  SignedPurchaseOrderWithoutPayment: 46,
  RiskInsuranceBinder: 47,
  RiskInsuranceProposal: 48,
  RiskInsurancePolicy: 49,
  RiskInsuranceEndorsement: 50,
  TodoChecklistItem: 51,
  SelectionFileCustomField: 52,
  PurchaseOrderFileCustomField: 53,
  OwnerProfile: 54,
  CreditMemo: 55,
  Receipt: 56,
  Takeoff: 57,
  Bill: 58,
  Specification: 59,
  Deposit: 60,
  ElectronicConsent: 61,
  ClientUpdate: 62,
  ProofOfPurchase: 63,
  ProposalSnapshot: 64,
  WorksheetAgreement: 65,
  ProposalAgreement: 66,
  Task: 67,
  SelectionOption: 68,
  Submittal: 69,
  TaskFileCustomField: 70,
  SelectionCatalogOption: 71,
  SubVendor: 72,
} as const;
